import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from './../../../../../Config/Firebase/config';
import { getCurrentDate } from './../../../../../Utility/utils';

const CommentForm = ({ user, blogId, blog, setBlog }) => {
    const [newCommentMsg, setNewCommentMsg] = useState('');
    const [commentError, setCommentError] = useState('');

    const handlePostComment = async (e) => {
        e.preventDefault();
        setCommentError('');
        let hasError = false;
        if (newCommentMsg.trim() === '') {
            setCommentError('Message is required');
            hasError = true;
        }
        if (hasError) {
            return;
        }
        if (!navigator.onLine) {
            return toast.error("no_internet_connection");
        }
        const blogRef = doc(db, "blogdata", blogId);
        try {
            if (!user) {
                return toast.info('Sign in to post a comment');
            } else {
                const newComment = {
                    date: getCurrentDate(),
                    userId: user?.uid,
                    username: user?.displayName,
                    comment: newCommentMsg,
                    profile: user?.photoURL,
                    reply: []
                }
                const updatedBlogData = {
                    ...blog,
                    comments: [
                        ...blog.comments,
                        newComment,
                    ]
                }
                await updateDoc(blogRef, updatedBlogData);
                setBlog((prevBlog) => ({ ...prevBlog, ...updatedBlogData }));
                toast.success("Comment Added Successfully");
                setNewCommentMsg('');
            }
        } catch (error) {
            toast.error("Could not Post Comment");
        }
    }

    return (
        <div className="add-comment">
            <div className="add-comment-inner">
                <h3 className="add-comment-title">
                    Add New Comment
                </h3>
                <span className="error">{commentError}</span>
                <textarea
                    className='comment-textarea'
                    placeholder='Type Your Comment'
                    value={newCommentMsg}
                    onChange={(e) => setNewCommentMsg(e.target.value)}
                >
                </textarea>
                <button className='btn' onClick={handlePostComment}>Post Comment</button>
            </div>
        </div>
    );
}

export default CommentForm;
